import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  background: #f0f2f4;

  & > div {
    position: fixed;
    width: 100vw;
    z-index: 99;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 5px;
    background: #f0f2f4;
    @media (min-width: 769px) {
      justify-content: space-between;
      position: fixed;
      padding-top: 10px;
      padding-bottom: 10px;
      max-width: 1200px;
      margin: 0 auto;
      left: 300px;
      width: calc(100vw - 330px);
    }
  }
`;

export const Brand = styled.div`
  & > img {
    width: auto;
    max-height: 50px;
  }
  @media (min-width: 769px) {
    & > img {
      width: auto;
      max-height: 65px;
    }
  }
`;

export const MenuLink = styled.a`
  background: #595353aa;
  color: white;
  line-height: 15px;
  font-size: 10px;
  padding: 5px;
  &:hover {
    color: white;
    background: #595353;
  }
  & * {
    color: white;
  }
  @media (min-width: 769px) {
    background: #595353aa;
    color: white;
    font-size: 16px;
    padding: 8px;
  }
`;

export const Actions = styled.div`
  display: none;
  & > * {
    //display: none;
    margin-left: 10px;
  }
  & > ${MenuLink} {
    display: block;
  }
  @media (min-width: 769px) {
    & > * {
      margin-left: 20px;
    }
    display: inline-flex;
    align-items: center;
  }
`;

export const OpenStoreSwitch = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  position: relative;
  & > span {
    position: absolute;
    bottom: -15px;
    line-height: 9px;
    font-size: 10px;
  }
`;
